<template>
    <section>
        <v-container class="nav">
            <v-card-title>
                <v-row align="center">
                    <v-col
                        cols="2"
                        sm="2"
                        lg="1"
                        class="pr-0"
                        align="right"
                    >
                        <v-avatar class="page-icon teal mr-2 elevation-5">
                            <v-icon large class="white--text">
                                {{ mdiFountainPenTip }}
                            </v-icon>
                        </v-avatar>
                    </v-col>
                    <v-col
                        cols="10"
                        sm="10"
                        lg="11"
                        class="pl-0"
                    >
                        <h2>FAQs</h2>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-divider />
        </v-container>

        <div class="faqs-main-content d-flex justify-space-around flex-wrap">
            <FAQS_1st_col />
            <!-- End 1st faqs-col-content -->

            <FAQS_2nd_col />
        </div>
    </section>
</template>

<script>
import FAQS_1st_col from '@/components/DashboardChildren/MemberGuidelines/FAQSComp/FAQS_1st_col.vue'
import FAQS_2nd_col from '@/components/DashboardChildren/MemberGuidelines/FAQSComp/FAQS_2nd_col.vue'
import { mdiFountainPenTip } from '@mdi/js'
export default {
    components: {
        FAQS_1st_col,
        FAQS_2nd_col
    },
    data: () => ({
        mdiFountainPenTip
    })
}
</script>

<style scoped>
section {
  background-image: url("../../../assets/dashboardBG.webp");
  background-position: center;
  background-size: cover;
}
h3 {
  font-size: 30px;
}
p {
  text-align: justify;
  margin-top: 15px;
}
.faqs-main-content {
  /* border: 1px solid red; */
  width: 90%;
  margin: auto;
}
.faqs-col-content {
  width: 700px;
  margin: 20px auto;
  /* border: 1px solid red; */
}
.faqs-col-content h3 {
  font-size: 30px;
}

.faqs-col-content h4 {
  width: 80%;
  margin-top: 20px;
  text-align: justify;
  color: #1b5e20;
}

.faqs-col-content ul {
  width: 80%;
}
.faqs-col-content ul li {
  padding-top: 15px;
  font-size: 17px;
  text-align: justify;
}

@media (max-width: 390px) {
  .page-icon {
    display: none;
  }
}

@media (max-width: 599px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 25px;
  }
  .faqs-col-content h3 {
    text-align: center;
    font-size: 25px;
  }

  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
}

@media (min-width: 599px) and (max-width: 968px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 30px;
  }
  .faqs-col-content {
    width: 95%;
  }
  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
}
@media (min-width: 968px) and (max-width: 1264px) {
  .nav {
    margin-top: 60px;
  }
  .nav h2 {
    font-size: 30px;
  }
  .faqs-col-content {
    width: 95%;
  }
  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
}
@media (min-width: 1264px) and (max-width: 1904px) {
  .faqs-col-content {
    width: 45%;
  }
  .faqs-col-content ul {
    width: 90%;
  }
  .faqs-col-content h4 {
    width: 100%;
  }
}
</style>
